import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { getDefaultTransition } from '../../utils/getDefaultTransition'
import { InputWrapperProps } from './types/inputWrapperProps'
import { InputSize } from './types/size'
import { getInputStyle } from './utils/getInputStyle'
import { getInputWrapperStyle } from './utils/getInputWrapperStyle'

export const InputWrapper = styled.div<InputWrapperProps>`
  ${(props) => getInputWrapperStyle(props, Input)};

  ${({ clearable }) =>
    clearable &&
    css`
      &:hover,
      &:focus-within {
        ${ClearInputWrapper} {
          opacity: 1;
          pointer-events: auto;
        }
      }
    `}
`

export const ClearInputWrapper = styled.div`
  opacity: 0;
  pointer-events: none;
  ${getDefaultTransition('opacity')};
`

interface InputProps {
  inputSize: InputSize
}

export const Input = styled.input<InputProps>`
  ${({ inputSize }) => getInputStyle(inputSize)};
`
